import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType } from 'components/list/DynamicListFilterUtils';

import { CATEGORY } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const CategoriesList = () => {
	const defaultSort = useMemo(() => [{ id: 'fullPath', desc: false }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'ID',
				accessor: 'ID',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'nameEn',
				accessor: 'nameEn',
				filterType: FilterType.string
			},
			{
				Header: 'nameAr',
				accessor: 'nameAr',
				filterType: FilterType.string
			},
			{
				Header: 'nameTr',
				accessor: 'nameTr',
				filterType: FilterType.string
			},
			{
				Header: 'parentNameEn',
				accessor: 'parentNameEn',
				filterType: FilterType.string
			},
			{
				Header: 'level',
				accessor: 'level',
				filterType: FilterType.number
			},
			{
				Header: 'assignedProductCount',
				accessor: 'assignedProductCount',
				filterType: FilterType.number
			},
			{
				Header: 'fullNameEn',
				accessor: 'fullNameEn',
				filterType: FilterType.string
			},
			{
				Header: 'fullPath',
				accessor: 'fullPath',
				filterType: FilterType.string
			},
			{
				Header: 'parentId',
				accessor: 'parentId',
				filterType: FilterType.string
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.PRODUCTS_CATEGORIES}
				columns={columns}
				fetchUrl={CATEGORY.GET_CATEGORY_LIST}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.PRODUCT}
				exportName="categories"
			/>
		</TabTableContainer>
	);
};

export default CategoriesList;
